<app-dialog [config]="data.informationData.getConfig()" (actionButtonClicked)="onActionButtonClicked($event)">
    <ng-container dialog-title>
        {{data.informationData.caption}}
    </ng-container>
    <ng-container dialog-process-in-progress>
        <div class="mb-2 d-flex justify-content-center">
            <p [innerHTML]="data.informationData.result|sanitizeHtml"></p>
        </div>
    </ng-container>
</app-dialog>
